import { useCallback, useContext } from 'react';
import _ from 'underscore';

import { PublicClientApplication } from '@azure/msal-browser';
import { InstrumentationServiceContext } from '@bingads-webui-campaign-react/smart-page-context';

import { msalConfig, customDomainLoginRequest } from './config';

const msalInstance = new PublicClientApplication(msalConfig);

export const useMsal = () => {
  const logger = useContext(InstrumentationServiceContext);

  const onLogin = useCallback((cb) => {
    msalInstance.loginPopup(customDomainLoginRequest)
      .then(res => _.isFunction(cb) && cb(res))
      .catch((err) => {
        if (err && err.errorCode !== 'user_cancelled') {
          logger.logError(err);
        }
      });
  }, [logger]);

  const onLogout = useCallback((cb) => {
    msalInstance.logoutPopup().then(() => _.isFunction(cb) && cb());
  }, []);

  return {
    onLogin,
    onLogout,
  };
};
